module.exports = __webpack_public_path__ + "img/logo-menu.ad283393.png";